import { Stack } from "@mui/material";
import { useGetClipboardScoreProfile } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { Info } from "./Info";

export function InviteRequiredModalContent() {
  const { userId } = useDefinedWorker();
  const { data: { clipboardScore = 0 } = {} } = useGetClipboardScoreProfile(userId);

  return (
    <Stack flex={1} position="relative" padding={5} justifyContent="center" alignItems="center">
      <Stack flex={1} spacing={7} py={10}>
        <Text variant="h2" textAlign="center">
          Your account is{" "}
          <Text noWrap inline variant="h2">
            invite-required
          </Text>
        </Text>
        <Info clipboardScore={clipboardScore} />
      </Stack>
    </Stack>
  );
}
